import { defineStore } from 'pinia';
import { computed } from 'vue';
import { useEntityStore } from '../../../common/composables/entityStore';
import type { MappingProfile } from '../domain/mappingProfile';

export const useMappingProfileStore = defineStore('mapping-profiles', () => {
  const { add, getById, clear, merge, remove, changed, getOrThrow, list } = useEntityStore<MappingProfile>({
    eventName: 'mapping-profile-changed',
    getEntityId(entity) {
      return entity.id;
    },
    updateEntity(dest, src) {
      dest.name = src.name;
      dest.description = src.description;
      dest.priority = src.priority;
      dest.sourceCode = src.sourceCode;
      dest.minWidth = src.minWidth;
      dest.maxWidth = src.maxWidth;
      dest.minHeight = src.minHeight;
      dest.maxHeight = src.maxHeight;
      dest.minLength = src.minLength;
      dest.maxLength = src.maxLength;
      dest.minMoisture = src.minMoisture;
      dest.maxMoisture = src.maxMoisture;
      dest.targetProductId = src.targetProductId;
      dest.targetPackageTypeId = src.targetPackageTypeId;
      dest.targetPackagingId = src.targetPackagingId;
    },
  });

  return {
    changed,
    getById,
    add,
    remove,
    getOrThrow,
    merge,
    clear,
    mappingProfiles: list,
    sortedByName: computed(() => {
      const clone = Array.from(list.value);
      clone.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
      return clone;
    }),
    sortedByPriority: computed(() => {
      const clone = Array.from(list.value);
      clone.sort((a, b) => a.priority - b.priority || a.name.localeCompare(b.name, undefined, { numeric: true }));
      return clone;
    }),
  };
});
